// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SkypeOutlinedSvg from "@fishx/icons-svg/es/asn/SkypeOutlined";
import FishxIcon from '../components/FishxIcon';

var SkypeOutlined = function SkypeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SkypeOutlinedSvg
  }));
};

SkypeOutlined.displayName = 'SkypeOutlined';
export default React.forwardRef(SkypeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SkypeOutlined.js
// module id = 4133
// module chunks = 0